import React from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

const sitekey = `${
  process.env.GATSBY_CAPTCHA_SITE_KEY_CHECKBOX ||
  process.env.GATSBY_CAPTCHA_SITE_KEY
}`;

const ReCaptcha = ({ onResolved, createRef }) => {
  const onErrored = () => {
    window.recaptcha?.current?.props?.reset();
  };

  return (
    <ReCAPTCHA
      ref={createRef}
      // size="invisible"
      sitekey={sitekey}
      onChange={onResolved}
      onErrored={onErrored}
      onExpired={() => window.recaptcha.current.props.reset()}
    />
  );
};

ReCaptcha.propTypes = {
  onResolved: PropTypes.func.isRequired,
  createRef: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default ReCaptcha;
